"use client";
import { jsx } from "react/jsx-runtime";
import { BaseAutocomplete } from "@pcln/horizon";
import { useCallback, useRef } from "react";
function AutocompleteField({ onInputValueChange, onSelectItem, ...rest }) {
    const lastSelectedItemNameRef = useRef(null);
    const handleInputValueChange = useCallback((inputValue)=>{
        if (null !== lastSelectedItemNameRef.current && inputValue === lastSelectedItemNameRef.current) {
            lastSelectedItemNameRef.current = null;
            return;
        }
        onInputValueChange(inputValue);
    }, [
        onInputValueChange
    ]);
    const handleSelectItem = useCallback((item, highlightedIndex)=>{
        if (item.isGroupHeader) return;
        lastSelectedItemNameRef.current = item.itemName;
        onSelectItem?.(item, highlightedIndex);
    }, [
        onSelectItem
    ]);
    return /*#__PURE__*/ jsx(BaseAutocomplete, {
        ...rest,
        onInputValueChange: handleInputValueChange,
        onSelectItem: handleSelectItem
    });
}
export { AutocompleteField };
